import { useState } from 'react'
import { supabase } from '../supabaseClient'
import Logo from '../components/Logo'
import { getAllClubs } from '../clubData'

const ALL_GAA_CLUBS = getAllClubs()

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [club, setClub] = useState('')
  const [clubSearch, setClubSearch] = useState('')
  const [showClubPicker, setShowClubPicker] = useState(false)
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [hp, setHp] = useState('') // honeypot — real users never fill this in
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const filteredClubs = ALL_GAA_CLUBS.filter(c =>
    c.name.toLowerCase().includes(clubSearch.toLowerCase())
  )

  async function handleSubmit() {
    if (!name.trim() || !email.trim() || !subject.trim() || !message.trim()) {
      setError('Please fill in all required fields.')
      return
    }
    if (hp) {
      // Honeypot field was filled in — silently pretend success, don't send
      setSent(true)
      return
    }
    setLoading(true)
    setError('')
    try {
      const { error: fnError } = await supabase.functions.invoke('send-invite-email', {
        body: {
          type: 'contact_form',
          name: name.trim(),
          email: email.trim(),
          club: club.trim(),
          subject: subject.trim(),
          message: message.trim()
        }
      })
      if (fnError) { setError('Something went wrong sending your message. Please try again.'); setLoading(false); return }
      setSent(true)
    } catch (e) {
      setError('Something went wrong sending your message. Please try again.')
    }
    setLoading(false)
  }

  if (sent) {
    return (
      <div style={shell}>
        <div style={card}>
          <div style={{ textAlign: 'center', marginBottom: '8px' }}>
            <Logo width="160px" maxWidth="160px" style={{ margin: '0 auto 20px' }} />
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>✅</div>
            <h2 style={{ fontSize: '19px', fontWeight: '600', marginBottom: '8px' }}>Message sent</h2>
            <p style={{ fontSize: '14px', color: '#888', lineHeight: '1.5' }}>
              Thanks for getting in touch — we'll get back to you as soon as we can.
            </p>
          </div>
          <button style={primaryBtn} onClick={() => { window.location.href = '/' }}>Back to home</button>
        </div>
      </div>
    )
  }

  return (
    <div style={shell}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <Logo width="160px" maxWidth="160px" style={{ margin: '0 auto 16px' }} />
          <h2 style={{ fontSize: '19px', fontWeight: '600', marginBottom: '6px' }}>Contact us</h2>
          <p style={{ fontSize: '13px', color: '#888' }}>Questions, feedback, or something not working right — let us know.</p>
        </div>

        {error && (
          <div style={{ background: '#FCEBEB', border: '0.5px solid #A32D2D', borderRadius: '8px', padding: '10px 12px', marginBottom: '16px', fontSize: '13px', color: '#A32D2D' }}>
            {error}
          </div>
        )}

        <input style={inputStyle} type="text" placeholder="Your name *"
          value={name} onChange={e => setName(e.target.value)} />
        <input style={inputStyle} type="email" placeholder="Your email *"
          value={email} onChange={e => setEmail(e.target.value)} />

        <div style={{ position: 'relative', marginBottom: '12px' }}>
          <input style={{ ...inputStyle, marginBottom: 0 }}
            type="text" placeholder="Your club (optional)"
            value={club || clubSearch}
            onChange={e => { setClubSearch(e.target.value); setClub(e.target.value); setShowClubPicker(true) }}
            onFocus={() => setShowClubPicker(true)}
          />
          {showClubPicker && clubSearch.length > 0 && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e0e0e0', borderRadius: '8px', maxHeight: '180px', overflowY: 'auto', zIndex: 50, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', marginTop: '4px' }}>
              {filteredClubs.slice(0, 15).map(c => (
                <div key={c.name + c.county} onClick={() => { setClub(c.name); setClubSearch(c.name); setShowClubPicker(false) }}
                  style={{ padding: '10px 12px', borderBottom: '0.5px solid #f0f0f0', cursor: 'pointer', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{c.name}</span>
                  <span style={{ fontSize: '11px', color: '#aaa' }}>{c.county}</span>
                </div>
              ))}
              {filteredClubs.length === 0 && (
                <div style={{ padding: '10px 12px', fontSize: '13px', color: '#aaa', fontStyle: 'italic' }}>No matching clubs — you can still type a custom name</div>
              )}
            </div>
          )}
        </div>

        <input style={inputStyle} type="text" placeholder="Subject *"
          value={subject} onChange={e => setSubject(e.target.value)} />
        <textarea style={{ ...inputStyle, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
          placeholder="Message *"
          value={message} onChange={e => setMessage(e.target.value)} />

        {/* Honeypot field — hidden from real users, bots tend to fill in every field */}
        <input
          type="text"
          name="website"
          value={hp}
          onChange={e => setHp(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
          style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
        />

        <button style={primaryBtn} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Sending...' : 'Send message'}
        </button>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <button style={linkBtn} onClick={() => { window.location.href = '/' }}>← Back to home</button>
        </div>
      </div>
    </div>
  )
}

const shell = { minHeight: '100vh', background: 'linear-gradient(135deg, #185FA5 0%, #0d3d6b 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }
const card = { background: 'white', borderRadius: '16px', padding: '28px 24px', width: '100%', maxWidth: '380px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }
const inputStyle = { display: 'block', width: '100%', padding: '12px 14px', marginBottom: '12px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }
const primaryBtn = { display: 'block', width: '100%', padding: '13px', background: '#185FA5', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: 'pointer' }
const linkBtn = { background: 'none', border: 'none', color: '#185FA5', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline' }